import {
  type Metafield,
  MetafieldKeys,
  MetafieldNamespaces,
} from "@/types/metafields";

export const getRatingFromMetafields = (
  metafields?: Metafield[],
): number | undefined => {
  const ratingMetafield = metafields?.find(
    (meta) =>
      meta?.key === MetafieldKeys.RATING &&
      meta?.namespace === MetafieldNamespaces.REVIEWS,
  );

  if (!ratingMetafield) return undefined;

  try {
    return JSON.parse(ratingMetafield.value).value;
  } catch (error) {
    console.error("Error parsing rating metafield value:", error);
    return undefined;
  }
};
